import { Account } from "../../model"

export enum Tax {
	AdditionnalTax = "TAXES_ADDITIONNAL_TAX",
	Attribution = "TAXES_ATTRIBUTION",
	EqualisationFund = "TAXES_EQUALISATION_FUND",
	PropertyTax = "TAXES_PROPERTY_TAX",
	OtherTax = "TAXES_OTHER_TAX"
}

export const TaxLabels = {
	additionnalTax: "Taxe additionnelle",
	attribution: "Attribution compensation",
	equalisationFund: "Fond péréquation",
	propertyTax: "Taxe foncière et habitation",
	otherTax: "Autres taxes"
}

export const taxNumbers = {
	additionnalTax: ["7381"],
	attribution: ["7321", "7322"],
	common: ["73"],
	equalisationFund: ["7325","73223"],
	propertyTax: ["731"]
}

/**
 * Vérifie si un compte est de type "Taxe additionnelle".
 * @param account
 */
export function accountIsAdditionnalTax(account: Account): boolean {
	if (!account || !account.number) return false
	return taxNumbers.additionnalTax.some(n => account.number.startsWith(n))
}

/**
 * Vérifie si un compte est de type "Attribution compensation".
 * @param account
 */
export function accountIsAttributionTax(account: Account): boolean {
	if (!account || !account.number) return false
	return taxNumbers.attribution.some(n => !account.number.startsWith("73223") && account.number.startsWith(n))
}

/**
 * Vérifie si un compte est de type "Fond péréquation".
 * @param account
 */
export function accountIsEqualisationFund(account: Account): boolean {
	if (!account || !account.number) return false
	return taxNumbers.equalisationFund.some(n => account.number.startsWith(n))
}

/**
 * Vérifie si un compte est d'une fiscalité indéfinie.
 * @param account
 */
export function accountIsUndefinedTax(account: Account): boolean {
	return accountIsTax(account) && !(
		accountIsAdditionnalTax(account)
		|| accountIsAttributionTax(account)
		|| accountIsEqualisationFund(account)
		|| accountIsPropertyTax(account)
	)
}

/**
 * Vérifie si un compte est de type "Taxe foncière et habitation".
 * @param account
 */
export function accountIsPropertyTax(account: Account): boolean {
	if (!account || !account.number) return false
	return taxNumbers.propertyTax.some(n => account.number.startsWith(n))
}

/**
 * Vérifie si un compte est de fiscalité.
 * 
 * Un compte est de fiscalité quand il est en recette de fonctionnement et que 
 * son numéro commence par 73.
 * 
 * @param account
 */
export function accountIsTax(account: Account): boolean {
	if (!(account && account.operation && account.receipts && account.number)) 
		return false
		
	return taxNumbers.common.some(n => account.number.startsWith(n))
}

/**
 * Vérifie si un compte est du type passé en paramètre.
 * @param account
 * @param tax
 */
export function accountIsTaxType(account: Account, tax: Tax): boolean {
	switch (tax) {
		case Tax.AdditionnalTax: return accountIsAdditionnalTax(account)
		case Tax.Attribution: return accountIsAttributionTax(account)
		case Tax.EqualisationFund: return accountIsEqualisationFund(account)
		case Tax.OtherTax: return accountIsUndefinedTax(account)
		case Tax.PropertyTax: return accountIsPropertyTax(account)
	}
}

/**
 * Obtient le libellé du compte passé en paramètre.
 * @param tax
 */
export function getTaxLabel(tax: Tax): string {
	switch (tax) {
		case Tax.AdditionnalTax: return TaxLabels.additionnalTax
		case Tax.Attribution: return TaxLabels.attribution
		case Tax.EqualisationFund: return TaxLabels.equalisationFund
		case Tax.OtherTax: return TaxLabels.otherTax
		case Tax.PropertyTax: return TaxLabels.propertyTax

		default: throw new RangeError("Valeur non valide.")
	}
}



// WEBPACK FOOTER //
// ./src/domain/sfp/tax-domain.ts